import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Divider from './Divider'
import LocationAndDateTime from './LocationAndDateTime'
import LocationWithMap from './LocationWithMap'
import StartAndEndDateTime from './StartAndEndDateTime'

import type { ThingToDoItem } from 'tripPlanner/types/tripItem'
import { isSamePlace } from 'tripPlanner/utils/places'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`

type Props = {
  item: ThingToDoItem
}

function StartAndEndPlaces({ item }: Props) {
  const intl = useIntl()

  const startLabel = intl.formatMessage({
    id: 'O9j2ihTQk8W3otXEAywh',
    defaultMessage: 'Start',
    description: 'Form field label for the start location/time of a trip item',
  })
  const endLabel = intl.formatMessage({
    id: 'vRrf-NHGuj6Y-emhQRw-',
    defaultMessage: 'End',
    description: 'Form field label for the end location/time of a trip item',
  })

  if (isSamePlace(item.startPlace, item.endPlace)) {
    return (
      <Wrapper>
        <LocationWithMap place={item.startPlace} />
        <StartAndEndDateTime startTitle={startLabel} endTitle={endLabel} item={item} />
      </Wrapper>
    )
  }
  return (
    <>
      <Divider />
      <LocationAndDateTime
        place={item.startPlace}
        placeLabel={startLabel}
        date={item.startDate}
        time={item.startTime}
        day={item.startDay}
      />
      <Divider />
      <LocationAndDateTime
        place={item.endPlace}
        placeLabel={endLabel}
        date={item.endDate}
        time={item.endTime}
        day={item.startDay}
      />
    </>
  )
}

export default StartAndEndPlaces
